import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const GET_DASHBOARD_ANALYTICS_ACTION = createAsyncThunk('/get/dashboard-analytics', async () => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_DASHBOARD_ANALYTICS);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});